export default __webpack_public_path__ + "static/media/klinikBiddokkes.1aeabb40.jpg";